import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const ErrorPage: FC = () => (
  <div>
    <FormattedMessage
      id="global.error.somethingWentWrong"
      defaultMessage="Something went wrong"
    />
  </div>
);
